//
//
//
//
//

import Chart from "chart.js";

export default {
  name: "Bar",
  props: {
    height: {
      type: Number,
      default: 200
    },
    legend: {
      type: Boolean,
      default: false
    },
    datasets: {
      type: Array,
      default: () => []
    },
  },

  data: () => ({
    chart: {},
    totalMax: 0,
  }),

  computed: {
    labels() {
      return this.datasets.reduce((a, b) => {
        if (a.labels && b.labels) {
          return a.labels.concat(b.labels);
        } else if (a.labels) {
          return a.labels;
        } else {
          return b.labels;
        }
      }, []);
    },

    chartOptions() {
      return {
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'day',
              unitStepSize: 4
            },
            stacked: true,
            gridLines: {
              display: true,
            }
          }],
          yAxes: [{
            stacked: true,
            gridLines: {
              display: true,
            },
            ticks: {
              beginAtZero: true,
              stepSize: this.totalMax * .3,
            },
            type: 'linear',
          }]
        },
        responsive: true,
        legend: this.legend ? {
          position: 'bottom'
        } : false,
        maintainAspectRatio: false,
      }
    }
  },

  watch: {
    datasets(newVal) {
      if (newVal) {
        this.createChart();
      }
    }
  },

  mounted() {
    this.createChart();
  },

  methods: {
    createChart() {
      if (this.chart &&
          Object.keys(this.chart).length !== 0) {
        this.chart.destroy();
      }

      const data = {
        labels: this.labels,
        datasets: this.datasets,
        borderSkipped: false,
      };

      const accumulatedDatasets = this.datasets.map((dataset) => {
        return dataset.data;
      }).reduce((prevData, data) => {
        return prevData.concat(data);
      }, [])

      this.totalMax = accumulatedDatasets.reduce((max, currentValue) => {
        return max < currentValue ? currentValue : max;
      }, 0)

      this.chart = new Chart(this.$refs.chart, {
        type: 'bar',
        data: data,
        options: this.chartOptions,
      });
    }
  }
}
